import { ActivityIndicator } from 'react-native'
import { RefreshControl } from 'react-native'
import { ScreenWrapper } from '../../../../../@ui/containers/grid/screen.wrapper'
import Row from '../../../../../@ui/containers/grid/row'
import { ClusterCard } from './cluster.card'
import { View } from 'react-native'
import { useTheme } from '../../../../../hooks/theme.hook'
import { ClusterListQuery } from '../../../../../generated/graphql'

const ClusterList = ({
  loading,
  data,
  onRefresh,
  onClusterSelected,
  onClusterContributionsPress,
  NoData,
}: {
  loading: boolean
  onRefresh: () => void
  data: ClusterListQuery['availableClusters']
  NoData: JSX.Element
  onClusterSelected: (clusterId: string) => void
  onClusterContributionsPress: (clusterId: string) => void
}) => {
  const theme = useTheme()

  return (
    <ScreenWrapper
      refreshControl={
        <RefreshControl refreshing={loading} onRefresh={onRefresh} />
      }
    >
      {loading && (
        <Row
          justifyContent={'center'}
          alignItems={'center'}
          style={{
            flex: 1,
            marginTop: theme.spacing(8),
          }}
        >
          <ActivityIndicator size={32} />
        </Row>
      )}
      {(data || []).map((cluster) => (
        <ClusterCard
          key={cluster.id}
          cluster={cluster}
          onPress={() => {
            onClusterSelected(cluster.id)
          }}
          onClusterContributionsPress={() => {
            onClusterContributionsPress(cluster.id)
          }}
        />
      ))}
      {data?.length === 0 && (
        <View style={{ marginTop: theme.spacing(8) }}>{NoData}</View>
      )}
      <View style={{ height: theme.spacing(32) }}>{/* spacer */}</View>
    </ScreenWrapper>
  )
}

export default ClusterList
